import { Link } from 'react-router-dom';
import './LegalFooter.css';
import FinancialDataDisclaimer from '../Legal/FinancialDataDisclaimer';

// App-wide legal footer, rendered once in Layout below the routed content.
// Provides global access to the legal pages (Terms, Privacy, Disclaimer) plus
// a compact provider-neutral data notice. Deliberately understated — muted
// colors, small type, not visually dominant — so it doesn't compete with the
// primary UI. The data notice text comes from the shared
// <FinancialDataDisclaimer>, which stays provider-neutral until data-provider
// licensing/attribution is confirmed (see src/config/dataProvider.js); this
// footer therefore carries NO third-party brand or logo today.
const LegalFooter = () => (
  <footer className="legal-footer" aria-label="Legal and data information">
    <nav className="legal-footer-links" aria-label="Legal">
      <Link to="/terms">Terms of Service</Link>
      <Link to="/privacy">Privacy Policy</Link>
      <Link to="/disclaimer">Disclaimer</Link>
    </nav>
    <div className="legal-footer-notice">
      <FinancialDataDisclaimer variant="inline" />
    </div>
  </footer>
);

export default LegalFooter;
